import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Icon, Breadcrumb, Segment, List, Label } from 'semantic-ui-react'

const CategoryPage = ({ node }) => {
  return (
    
      <List.Item>
        <Link key={node.id} to={`/category/${node.slug}/`}  style={{fontSize: '20px',  margin: '10px'}}>
        {node.name}
      </Link>
      </List.Item>

  )
}

const CategoriesPage = ({ data }) => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
    <Helmet>
      <title>Find SaaS growth tools by category | Find Growth Tools</title>
      <meta name="description" content="Discover the best SaaS growth tools, listed by product category." />
    </Helmet>
    {/* <Segment basic>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/" 	style={{color: '#dcddde'}}>
            <Icon name="home" />
          </Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider 	style={{color: '#fff'}}/>
      </Breadcrumb>
    </Segment> */}

    <Segment basic>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/" 	style={{color: '#dcddde'}}>
            <Icon name="angle left" /> Home
          </Link>
        </Breadcrumb.Section>
      </Breadcrumb>
    </Segment>
    
    <h1
      style={{
        fontSize: '1.5rem',
        color: '#fff'
      }}
    >
      Find SaaS growth tools by
      <span style={{ fontSize: '3.25rem' }}> Category</span>
    </h1>
    <br />
    
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
    <Segment>
      <List>
        {data.allContentfulCategory.edges.map(edge => (
          <CategoryPage node={edge.node} />
        ))}
      </List>
      </Segment>
      <br/>
    </div>
  </div>
)

export default CategoriesPage

export const pageQuery = graphql`
  query pageQuery {
    allContentfulCategory(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          name
          slug
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/categories.js